/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj_create_unique_id, split_once } from './util.js';
import { showSnackbar } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { MCUnknown } from './media.unknown.js';
import { MThumbnails } from './thumbnails.js';


export let MCAudio = function($,mj) {

	var media_class = 3;
	var audio_suffixes = {
		'audio/mp4':  'm4a',
		'audio/mpeg': 'mp3',
		'audio/ogg':  'oga',
	};
	var audio_format_display_names;
	var html5_controls_height = null;

	// $(function() {
	// 	// translations are available on DOMContentLoaded ..
	// 	audio_format_display_names = {
	// 		'audio/mp4':  mjt('md-audio-mp4'),
	// 		'audio/mpeg': mjt('md-audio-mp3'),
	// 		'audio/ogg':  mjt('md-audio-ogg'),
	// 	};
	// });

	var m_test_audio = null;
	var m_test_cache = {};

	// determine whether browser supports playback of given preview format
	function can_play( pf ) {
		var html5_mime_type = pf.html5_mime_type;
		if( m_test_cache.hasOwnProperty(html5_mime_type) ) return m_test_cache[html5_mime_type];
		if( !m_test_audio  ) m_test_audio = document.createElement('audio');
		if( !m_test_audio || !m_test_audio.canPlayType ) return false;
		var r = m_test_audio.canPlayType(html5_mime_type);
		return m_test_cache[html5_mime_type] = r=='maybe' || r=='probably';
	}

	function get_pf_display_name( pf ) {
		var html5_mime_type = pf.html5_mime_type;
		var tmp = split_once(html5_mime_type,';');
		var ctype = tmp[0];
		if( audio_format_display_names.hasOwnProperty(ctype) ) return audio_format_display_names[ctype];
		return html5_mime_type;
		// return ctype;
	}


	return Object.assign( {}, MCUnknown, {

		init: function() {
			audio_format_display_names = {
				'audio/mp4':  mjt('md-audio-mp4'),
				'audio/mpeg': mjt('md-audio-mp3'),
				'audio/ogg':  mjt('md-audio-ogg'),
			};
		},

		getSourceDimensions: function( dtinfo ) {
			var meta = dtinfo.meta,
				has_custom_preview = meta[10] && meta[10][0] > 0,
				w = has_custom_preview && meta[10] ? parseInt(meta[10][0],10) : 1920/2,
				h = has_custom_preview && meta[11] ? parseInt(meta[11][0],10) : 1080/2,
				r = (w/h);
			return [w,h,r];
		},

		getPosterImageSrc: function( dtinfo, dsp_w, dsp_h, fill ) {
			var media_id = dtinfo.media_id,
				meta = dtinfo.meta,
				has_custom_preview = meta[10] && meta[10][0] > 0,
				vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '',
				fq = fill ? '&fill=1&transparency=1&bg_color=00000000' : '';
			if( dsp_w===0 && dsp_h===0 ) {
				dsp_w = has_custom_preview && meta[10] ? parseInt(meta[10][0],10) : 1920/2;
				dsp_h = has_custom_preview && meta[11] ? parseInt(meta[11][0],10) : 1080/2;
			} else {
				for( var i=0; i<8 && (dsp_w<200&&dsp_h<200)||(dsp_w<100||dsp_h<100); ++i ) {
					dsp_w *= 2;
					dsp_h *= 2;
				}
				dsp_w = Math.floor(dsp_w);
				dsp_h = Math.floor(dsp_h);
			}
			return has_custom_preview
				? mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+media_class+'_0_'+dsp_w+'_'+dsp_h+'.png?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq
				: mj.webroot+'media/file/preview/id/'+media_id+'_'+media_class+'_1_'+dsp_w+'_'+dsp_h+'.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq;
		},

		getXodURL: function( dtinfo, vid_w, vid_h, force_xod ) {
			var media_id = dtinfo.media_id,
				meta = dtinfo.meta,
				has_custom_preview = meta[10] && meta[10][0] > 0,
				vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '',
				fq = force_xod ? '&force_xod=1' : '';
			if( vid_w===0 && vid_h===0 ) {
				vid_w = has_custom_preview && meta[10] ? parseInt(meta[10][0],10) : 1920/2;
				vid_h = has_custom_preview && meta[11] ? parseInt(meta[11][0],10) : 1080/2;
			}
			return has_custom_preview
				? mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+media_class+'_0_'+vid_w+'_'+vid_h+'.xod?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq
				: mj.webroot+'media/file/preview/id/'+media_id+'_'+media_class+'_1_'+vid_w+'_'+vid_h+'.xod?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq;
		},

		createPreview: function( dtinfo, target, xopts ) {
			var md_trg = $(target),
				media_id = dtinfo.media_id,
				meta = dtinfo.meta,
				md_audio = null,
				md_closed = false,
				// viewport dimensions
				md_view_w = Math.max( 10, md_trg.width()-10 ),
				md_view_h = Math.max( 10, md_trg.height()-10 ),
				// previous display dimensions - to avoid reload when they don't change
				md_prev_display_w = -1, md_prev_display_h = -1,
				// available preview formats & the currently selected one
				available_preview_formats = {},
				md_cur_pf_id = -1,
				// available after "mjstoolbarsetup"
				md_afmt_select=null, md_afmt_loading=null, md_afmt_progress=null;


			function _selectPreviewFormatById( id, update_select ) {
				md_cur_pf_id = id;
				if( md_afmt_select && update_select ) md_afmt_select.val(md_cur_pf_id).trigger('change.select2');
				if( md_cur_pf_id!==-1 ) md_trg.triggerHandler('mjspreviewformatchanged',available_preview_formats[md_cur_pf_id]);
			}

			function close_handler( unbind ) {
				if( md_audio ) {
					var html5_audio = md_audio.children('.audio');
					if( html5_audio.length ) {
						// firefox does not always stop the audio when its detached from DOM, so manually stop it now
						if( html5_audio[0].pause ) {
							html5_audio[0].autobuffer = false;
							html5_audio[0].preload = 'none';
							html5_audio[0].pause();
						}
					}
					if( md_audio ) {
						md_audio.remove();
						md_audio = null;
					}
				}
				if( unbind ) {
					md_trg.off('.MCAudio');
					md_closed = true;
				}
				md_trg.removeClass('md-audio-canvas');
			}

			function show_preview( force_update, auto_play ) {

				var cur_pf = available_preview_formats[md_cur_pf_id]||null,
					// viewport dimensions
					view_w = Math.max(10,Math.min(1920/2, md_view_w )),//Math.round(0.800*md_view_w),
					view_h = Math.max(10,Math.min(1080/2, md_view_h ));//Math.round(0.600*md_view_h);

				/*
				// display dimensions of poster image
				var dsp_w = Math.max(10,Math.min(800,Math.round(0.800*view_w))),
					dsp_h = Math.max(10,Math.min(343,Math.round(0.343*view_h)));
				*/

				var src_dim = mj.mc_ns[3].getSourceDimensions(dtinfo);
				var dsp_dim = MThumbnails.getImageDimsScaledToBox2(view_w,view_h,src_dim[0],src_dim[1],true);
				var dsp_w0 = dsp_dim[0],
					dsp_w = Math.max(view_w,dsp_w0),//Math.max(10,Math.min(800, Math.max(view_w,dsp_dim[0]) )),
					dsp_h = dsp_dim[1];//Math.max(view_h,dsp_dim[1]);//Math.max(10,Math.min(600, Math.max(view_h,dsp_dim[1]) ));

				//console.log(['MCAudio.show_preview',   'md_prev_display_w='+md_prev_display_w,'md_prev_display_h='+md_prev_display_h,   'dsp_w='+dsp_w,'dsp_h='+dsp_h,   'view_w='+view_w,'view_h='+view_h  ]);
				if( !force_update && md_audio && md_prev_display_w==dsp_w && md_prev_display_h==dsp_h ) {
					// re-center the player and return
					//md_audio.css( { width:dsp_w+'px', height:dsp_h+'px' } );
					return;
				}
				md_prev_display_w = dsp_w;
				md_prev_display_h = dsp_h;


				// save current play status & position
				var cur_time = 0;
				var cur_paused = true;
				var cur_ended = false;
				var cur_html5_audio = md_audio && md_audio.children('.audio');
				if( cur_html5_audio && cur_html5_audio.length ) {
					cur_paused = cur_html5_audio[0].paused;
					cur_ended = cur_html5_audio[0].ended;
					cur_time = cur_html5_audio[0].currentTime;
					if( cur_ended ) cur_time = 0;
				}

				// remove previous player instance(s)
				close_handler(false);

				// add new player instance ...
				if( cur_pf===null ) {
					// no format available -> show custom preview or icon or something similar ...
					return MCUnknown.createPreview(dtinfo,target,xopts);
				}

				if( html5_controls_height===null ) {
					var audio0 = md_trg.html('<audio class="audio" controls style="display:none"></audio>').children();
					html5_controls_height = audio0.height();
					//console.log(['audio0=',audio0, 'html5_controls_height=',html5_controls_height]);
					audio0.remove();
				}

				// setup source urls
				// add outer container
				md_trg.addClass('md-audio-canvas');
				var mda_css = {};
				if( !xopts.no_poster_bg ) {
					var poster_fill = xopts.in_annotation_view ? false : true;
					var poster_h = Math.max(10,dsp_h-html5_controls_height);
					var poster_src = mj.mc_ns[3].getPosterImageSrc(dtinfo,dsp_w,poster_h,poster_fill);
					mda_css['background-image'] = 'url('+poster_src+')';
				}
				if( xopts.in_annotation_view ) {
					mda_css['min-width'] = Math.min(view_w,dsp_w0)+'px';
					mda_css['width'] = dsp_w0+'px';
					mda_css['max-width'] = dsp_w+'px';
					mda_css['height'] = '100%';// dsp_h+'px';
				} else {
					mda_css['width'] = dsp_w+'px';
					mda_css['max-width'] = dsp_w+'px';
					mda_css['min-height'] = dsp_h+'px';
				}

				md_audio = md_trg.html(  '<div id="'+mj_create_unique_id('md_audio_')+'" class="md-audio'+(xopts.no_poster_bg?'':' with-poster')+'">'
										+ '<div class="md-audio-inner" style="width:'+dsp_w+'px; height:'+dsp_h+'px" title="'+mjt('md-audio-click')+'"></div>'
										+'</div>' )
					.children()
					.css(mda_css);

				var src1 = mj.webroot+'media/file/stream_preview/id/'+media_id+'_'+md_cur_pf_id,
					vq3 = !dtinfo.is_latest_version ? '?version='+encodeURIComponent(dtinfo.version) : '';

				md_audio.html(	 '<audio class="audio'+(xopts.no_poster_bg?'':' with-poster')+'"'
									+' width="'+Math.floor(dsp_w)+'" height="'+Math.floor(dsp_h)+'"'
									+' style="width:'+dsp_w+'px; height:'+dsp_h+'px"'
									+' controls'
									+' autobuffer'
									+' preload="auto"'
									//+' controlsList="nodownload"'
									+(auto_play?' autoplay':'')
									+'>'
									+  '<source src="'+src1+'.'+cur_pf.sfx+vq3+'" type=\''+cur_pf.html5_mime_type+'\'>'
									+  '<br /><br />'+mjt('md-no-audio-support')+'<br /><br /><a href="'+src1+'.mp4'+vq3+'">'+mjt('md-no-audio-support-download')+'</a>'
									+'</audio>'
				);
				var new_html5_audio = md_audio.children('.audio');

				// restore play status & position
				if( cur_time > 0 ) {
					new_html5_audio[0].load();
					new_html5_audio[0].currentTime = cur_time;
					if( cur_paused ) new_html5_audio[0].pause(); // ignore auto_play argument ??
				}

				new_html5_audio[0].addEventListener( 'loadedmetadata', function(e) {
					md_trg.triggerHandler('mjslayoutchanged',e.type);
				}, true );
				new_html5_audio[0].addEventListener( 'loadeddata', function(e) {
					md_trg.triggerHandler('mjslayoutchanged',e.type);
				}, true );
				new_html5_audio[0].addEventListener( 'error', function(e) {
					var media_error = new_html5_audio[0].error;
					var error_str = media_error ? ( media_error.message + ' (code='+media_error.code+')' ) : 'unknown';
					showSnackbar('Audio error: '+error_str);
				}, true );

				if( xopts.setup_html5mediaelem ) xopts.setup_html5mediaelem(new_html5_audio[0],cur_pf);
			}

			// bind handlers
			md_trg
				.off('.MCAudio')
				.on( 'mjsclose.MCAudio', function(e) {
					close_handler(true);
				} )
				.on( 'mjsresize.MCAudio', function(e,w,h) {
					// save new viewport dimensions
					md_view_w = Math.max(10,w-10);
					md_view_h = Math.max(10,h-10);
					// show
					show_preview(false,false);
				} )
				.on( 'mjstoolbarsetup.MCAudio', function(e,toolbar,is_triggered_here) {

					// toolbar setup handler
					function init_with_preview_formats( j ) {
						available_preview_formats = j;

						// if download permission is available, then add source file to preview formats selection
						if( dtinfo.r_download ) {
							var src_format = meta[-2]&&meta[-2][0] ? meta[-2][0] : 'application/octet-stream',
								src_aud_codec = meta[404]&&meta[404][0] ? meta[404][0] : 'unknown',
								playable_hack = src_format=='audio/mpeg'
									? (src_aud_codec=='MP3'||src_aud_codec=='mp3')			// we expect, that flash player can decode MP3 audio...
									: ( src_format=='audio/mp4'
										? src_aud_codec=='AAC'||src_aud_codec=='aac'		// we expect, that the flash player can decode AAC audio, but no other codecs which may be used in an MP4 file
										: true )											// non-MP4-files are harmless - the following code will filter that, depending on browser's audio support
								;
							if( playable_hack ) {
								available_preview_formats[0] = {
									media_class:	media_class,
									sort:			-1,
									format:			src_format,
									name:			mjt('md-audio-format-original'),
									file_size: 		meta[5]&&meta[5][0] ? meta[5][0] : -1,

									aud_codec:		src_aud_codec,
									aud_duration:	meta[400]&&meta[400][0] ? meta[400][0] : -1,
									aud_channels:	meta[401]&&meta[401][0] ? meta[401][0] : -1,
									aud_samplerate:	meta[403]&&meta[403][0] ? meta[403][0] : -1,
								};
							}
						}

						var pf_id;
						// sort the formats
						var pf_ids_sorted = [];
						for( pf_id in available_preview_formats ) {
							if( !available_preview_formats.hasOwnProperty(pf_id) ) continue;
							pf_ids_sorted.push(pf_id);
						}
						pf_ids_sorted.sort( function(a,b) {
							return available_preview_formats[a].sort - available_preview_formats[b].sort;
						} );


						// add available preview formats to selection
						for( var idx=0; idx<pf_ids_sorted.length; idx++ ) {
							pf_id=pf_ids_sorted[idx];
							var pf=available_preview_formats[pf_id];
							if( pf.media_class!=media_class ) continue; // skip non-audio previews

							// add commly queried properties to preview format..
							pf.sfx = ( pf.mux_file_sfx ? pf.mux_file_sfx : audio_suffixes[pf.format] ) || 'bin';
							pf.html5_mime_type = pf.mux_html5_type ? pf.mux_html5_type : ( pf.mux_mime_type ? pf.mux_mime_type : pf.format );
							pf.browser_can_play = can_play(pf);

							if( pf.browser_can_play ) {
								if( md_cur_pf_id==-1 ) {
									// select first one..
									md_cur_pf_id = pf_id;
								} else {
									// select this format if it fits better than current one
									var cur_pf = available_preview_formats[md_cur_pf_id];
									if( pf.browser_can_play && !cur_pf.browser_can_play ) {
										// prefer supported audio
										md_cur_pf_id = pf_id;
									}
								}
								// add to selection
								// var fmt_dur = MDLocale.fmt_duration(pf.aud_duration,true),
								var fmt_chs = pf.aud_channels==2 ? 'Stereo' : ( pf.aud_channels==1 ? 'mono' : pf.aud_channels+' channels' );
								var fmt_sr = pf.aud_samplerate + 'Hz';
								var pf_text = get_pf_display_name(pf)+' '+fmt_chs+' '+fmt_sr;

								if( mj.debug ) {
									if( pf.hasOwnProperty('file_size') && pf.file_size ) {
										pf_text += ' sz='+MDLocale.fmt_filesize(pf.file_size,true);
									}
								}

								if( pf.name ) pf_text += ' ('+pf.name+')';
								$('<option/>')
									.attr('value',pf_id)
									.text(pf_text)
									.appendTo(md_afmt_select);
							}
						}

						if( mj.debug ) {
							$('<button type="button" class="tiny-debug"><span class="label">debug info</span></button>')
								.click( function() {
									var dbg_info = [];
									for( var dbg_idx=0; dbg_idx<pf_ids_sorted.length; dbg_idx++ ) {
										var dbg_pf_id=pf_ids_sorted[dbg_idx];
										var dbg_pf = available_preview_formats[dbg_pf_id];
										dbg_info.push(
											{
												id: dbg_pf_id,
												name: dbg_pf.name,
												mux_html5_type: dbg_pf.mux_html5_type ? dbg_pf.mux_html5_type : ( dbg_pf.mux_mime_type ? dbg_pf.mux_mime_type : dbg_pf.format ),
												sz: dbg_pf.file_size ? MDLocale.fmt_filesize(dbg_pf.file_size,true) : 'unknown',
											}
										);
									}
									var xPageDebug = window.MVPageDebug;
									if( window.parent && window.parent.MVPageDebug ) xPageDebug = window.parent.MVPageDebug;
									xPageDebug.dprint(dbg_info);
									xPageDebug.dprint(available_preview_formats);
								})
								.insertAfter(md_afmt_select);
						}


						_selectPreviewFormatById(md_cur_pf_id,true);
						md_afmt_loading.remove();
						md_afmt_progress.remove();
						if( md_afmt_select.children('option').length==0 ) {
							md_afmt_select.replaceWith( '<span>'+mjt('md-audio-no-preview-available')+'</span>' );
						} else {
							md_afmt_select
								.val(md_cur_pf_id)
								.show()
								.change( function() {
									// switch to selected preview format
									_selectPreviewFormatById(this.options[this.selectedIndex].value,false);
									show_preview(true,true);
									// set focus to media elem (so, e.g. pressing SPACE will play/pause)
									$(this).blur();
									if( md_audio ) md_audio.find('.audio').focus();
								} );
						}
					}

					function init_query_preview_progress( prioritize_counter ) {
						// check server-side progress...
						$.postJSON('json/media/meta-mprevprogress', 'media_id='+encodeURIComponent(media_id)+(prioritize_counter==0?'&prioritize=1':''), function(j) {
							if( j && ( j.hasOwnProperty('p') || j.retry ) ) {
								// in progress.. (either post import or delayed post import)
								// show/update progress info..
								md_afmt_loading.remove();
								var percent = j.hasOwnProperty('p') ? 0.1 * j.p : 0.0,
									progress_indicator = md_afmt_progress.show(),
									avl_width = progress_indicator.find('.outer').width()||0;
								progress_indicator.find('.inner').css('width',Math.round(avl_width*percent/100.0)+'px');
								// re-query
								setTimeout( function() {
									if( !md_closed ) init_query_preview_progress( prioritize_counter==9 ? 0 : prioritize_counter+1 );
								}, 2000 );
							} else {
								// not in progress.. -> try to get preview formats, but don't further check progress information
								init_query_preview_formats(false);
							}
						});
					}

					function init_query_preview_formats( query_progress ) {
						if( dtinfo.is_latest_version ) {
							if( query_progress ) {
								init_query_preview_progress(0);
							} else {
								// get available preview formats
								$.postJSON('json/media/meta-mprevfmts', 'media_id='+encodeURIComponent(media_id)+'&media_class='+media_class, function(j) {
									if( j ) {
										init_with_preview_formats(j);
									} else {
										md_afmt_loading.remove();
										md_afmt_progress.remove();
									}
									show_preview(true,false);
								});
							}
						} else {
							// show - even without any preview formats (with some luck, we can playback the original file)
							md_afmt_loading.remove();
							md_afmt_progress.remove();
							show_preview(true,false);
						}
					}

					// add custom control with preview format selection
					var md_afmt_select_id = mj_create_unique_id('md-afmt-select-');
					$('.left-edge',toolbar).after(
						'<td class="section md-aud-ctrls-1">'
							+ '<label for="'+md_afmt_select_id+'">'+mjt('md-audio-select-format')+'</label>'
							+ '<select id="'+md_afmt_select_id+'" class="md-afmt-select" style="display:none"></select>'
							+ '<span class="md-afmt-loading">'+mjt('md-audio-loading-formats')+'</span>'
							+ '<span class="md-afmt-progress" style="display:none">'+mjt('md-audio-preview-generating')+'<br /><span class="outer"><span class="inner"></span></span></span>'
						+'</td>'
						+'<td class="separator"></td>' );
					md_afmt_select = $('.md-afmt-select',toolbar);
					md_afmt_loading = $('.md-afmt-loading',toolbar);
					md_afmt_progress = $('.md-afmt-progress',toolbar);

					// get available preview formats - if n/a, then start querying progress information..
					init_query_preview_formats(true);
				} );
		},
	} );

}(jQuery,mj); // namespace MCAudio
